// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__oVNem","unreadBadge":"styles_unreadBadge__31H8W","modalContent":"styles_modalContent__ZW5un","modal":"styles_modal__qDTCk"};